"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var colors_1 = require("../colors");
var MuiOutlinedInput = {
  styleOverrides: {
    root: {
      backgroundColor: colors_1.colors.Neutros0,
      borderRadius: 8,
      'fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: colors_1.colors.Neutros40
      },
      '&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: colors_1.colors.WomCorp
      }
    }
  },
  defaultProps: {
    color: "primary"
  }
};
exports.default = {
  MuiOutlinedInput: MuiOutlinedInput
};